import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { isTokenExpired, removeTokens, getAccessToken, setAccessToken, getRefreshToken } from "./utils/auth";
import axios from "axios";
import { API_URL } from "./constants/data";
import { CircularProgress, Box } from "@mui/material";

const ProtectedRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const token = getAccessToken();

      if (!token) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }


      if (!isTokenExpired(token)) {
        setIsAuthenticated(true);
        setIsLoading(false);
        return;
      }


      try {
        const refreshToken = getRefreshToken();
        const response = await axios.post(
          `${API_URL}/refresh`,
          { refresh_token: refreshToken },
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );

        if (response.status === 200 && response.data.access_token) {
          setAccessToken(response.data.access_token);
          setIsAuthenticated(true);
        } else {
          removeTokens();
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Session restoration failed:", error);
        removeTokens();
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default ProtectedRoute;
